import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { CustomerQuestion } from '@services/api'

export const fetchQuestions = createAsyncThunk(
  'customerQuestion/fetchQuestions',
  async (params: any) => {
    const response = CustomerQuestion.fetchCustomerQuestions(params)
    return response
  }
)

export const downloadQuestions = createAsyncThunk(
  'customerQuestion/downloadQuestions',
  async (params: any) => {
    const response = CustomerQuestion.downloadCustomerQuestions(params)
    return response
  }
)

export const markWaitingForAnswer = createAsyncThunk(
  'customerQuestion/markWaitingForAnswer',
  async () => {
    const response = CustomerQuestion.markWaitingForAnswer()
    return response
  }
)

const initialState = {
  questionList: [],
  pageIndex: 1,
  pageSize: 10,
  totalPage: 0,
  totalRecords: 0,
  keyword: '',
  type: '',
  from: '',
  to: '',
  isDownloading: false,
  newQuestionCount: 0
}

const customerQuestionSlice = createSlice({
  name: 'customerQuestion',
  initialState,
  reducers: {
    setKeyword: (state, action) => {
      state.keyword = action.payload
    },
    setType: (state, action) => {
      state.type = action.payload
    },
    setFrom: (state, action) => {
      state.from = action.payload
    },
    setTo: (state, action) => {
      state.to = action.payload
    },
    setDownload: (state, action) => {
      state.isDownloading = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchQuestions.fulfilled, (state, action) => {
      state.questionList = action.payload.data
      state.pageIndex = action.payload.pageIndex
      state.pageSize = action.payload.pageSize
      state.totalRecords = action.payload.totalRecords
      state.totalPage = action.payload.totalPage
    })
  }
})

export const {
  setKeyword,
  setType,
  setFrom,
  setTo,
  setDownload
} = customerQuestionSlice.actions

export default customerQuestionSlice.reducer
